import { ApiResponse } from "../../../types/api";
import { AxiosError } from "axios";
import apiClient, { tokenManager } from "../../apiClient";
import { LoginRequest, LoginResponse, User } from "./type";

export const authService = {
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    try {
      const response = await apiClient.post<ApiResponse<LoginResponse>>(
        "/auth/login",
        credentials,
      );

      if (response.data.success) {
        tokenManager.setToken(response.data.data.accessToken);

        const userDetails = await authService.getCurrentUserDetails();
        const loginData = {
          ...response.data.data,
          user: userDetails,
        };

        localStorage.setItem("userData", JSON.stringify(userDetails));
        return loginData;
      } else {
        throw new Error(response.data.message);
      }
    } catch (error: unknown) {
      if (error instanceof AxiosError && error.response?.data?.message) {
        throw new Error(error.response.data.message);
      }
      throw new Error("Login failed. Please try again.");
    }
  },

  getCurrentUserDetails: async (): Promise<User> => {
    const response = await apiClient.get<ApiResponse<User>>("/users/profile");
    return response.data.data;
  },

  logout: (): void => {
    tokenManager.removeToken();
    localStorage.removeItem("userData");
  },

  getCurrentUser: (): User | null => {
    try {
      const userData = localStorage.getItem("userData");
      return userData ? JSON.parse(userData) : null;
    } catch {
      return null;
    }
  },

  isAuthenticated: (): boolean => {
    return !!tokenManager.getToken();
  },
};
